import React, { useState, useEffect } from "react";
import axios from "axios";

const ConsolidatedTeam = ({ startDate, endDate, token }) => {
  console.log("ConsolidatedTeam", startDate, endDate, token);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/CallCentreSalesReports/ConsolidatedTeamSBIReport?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {data && data.data.length > 0 ? (
        <>
          <h3>Data:</h3>
          <pre>{JSON.stringify(data.data, null, 2)}</pre>
        </>
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default ConsolidatedTeam;
